import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import InternalCommunicationView from './InternalCommunicationView.vue';

const PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/team'),
    name: 'internal_communication',
    meta: {
      permissions: PERMISSIONS,
      featureFlag: FEATURE_FLAGS.INTERNAL_COMMUNICATION,
    },
    component: InternalCommunicationView,
  },
  {
    path: frontendURL('accounts/:accountId/essential/team'),
    name: 'essential_internal_communication',
    meta: {
      permissions: PERMISSIONS,
      featureFlag: FEATURE_FLAGS.INTERNAL_COMMUNICATION,
    },
    component: InternalCommunicationView,
    props: { essentialMode: true },
  },
];
